import {
	getPermissionSubjectForEntity,
	getPermissionSubjectForEntityTab,
} from '@/generated/entity-config'
import type { AppAbility } from '@/integrations/casl/ability'

export function getEntityTabPermissionSubject(
	entity: string,
	tab: string,
): string | undefined {
	const normalizedTab = tab === 'details' ? 'detail' : tab
	const subject = getPermissionSubjectForEntityTab(entity, normalizedTab)
	return subject ? String(subject) : undefined
}

export function canReadEntityOrTab(
	ability: AppAbility,
	entity: string,
	tab?: string,
): boolean {
	if (!entity) {
		return false
	}

	const entitySubject = getPermissionSubjectForEntity(entity)
	if (!entitySubject) {
		return false
	}

	if (!tab) {
		return ability.can('read', String(entitySubject))
	}

	const tabSubject = getEntityTabPermissionSubject(entity, tab)
	if (!tabSubject) {
		return false
	}

	return ability.can('read', tabSubject)
}

export function filterReadableTabs(
	ability: AppAbility,
	entity: string,
	tabs: Array<{ label: string; value: string }>,
): Array<{ label: string; value: string }> {
	return tabs.filter((tab) => canReadEntityOrTab(ability, entity, tab.value))
}

export function firstReadableTab(
	ability: AppAbility,
	entity: string,
	tabs: string[],
): string | undefined {
	for (const tab of tabs) {
		if (canReadEntityOrTab(ability, entity, tab)) {
			return tab
		}
	}

	return undefined
}
